module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-06.4c13f4ad.png";